/*
hasil result search after user enter
*/
//@flow
import React from "react";
import KickImage from 'Reuseables/KickImage';
import classNames from "classnames";
import { connect } from "react-redux";
import Sneaker from "../Sneakers/Sneaker";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Button, Input, Form, Collapse } from "reactstrap";
import _ from "lodash";
import { hideLoading } from "react-redux-loading-bar";

import FilterAndSort from "../PageSearchDetails/FilterAndSort";
import LoadingSeller from "../Forms/SellingForm/LoadingSeller";
import CloseIcon from "../../images/close-button-search.png";
import NotFoundImg from "../../images/dashboard-empty-state.png";
import withScrollTo from "../hoc/withScrollTo";

import {
  doFetchProfile, doFetchCurrencyRate
} from "../../actions/authAction";
import {
  searchProduct,
  doBrowseAll,
  searchToLoadMore,
  updateActiveId,
  doFetchProducts,
  doFilteringSearchToApi,
  sortingSearchResultAPI,
  saveSearchQueries,
  doFetchPopularSearch,
  getCollectionBySlug,
  getCollectionProduct,
  searchState,
  fetchCollectionProduct,
  getAdditionalPage, 
  getDetailSection,
  getTopSellingProduct
} from "../../actions/productAction";
import Analytics from '../../services/Analytics';
import CardLoading from "../Loading/CardLoading";
import InputSearch from "../Forms/Input/InputSearch";
import { isFromAppBrowser, categoryString, categorySearch, convertToRupiah, getCloudImageUrl, convertBrandNameToSlug } from "../../utils/Helpers";
import { CURRENCY_CODE } from '../../constants';
import SneakerLoadingSpinner from "../Sneakers/SneakerLoadingSpinner";

//filter and sort
import { getAllBrands, getAllSizes } from '../../actions/filterAction';
import { doSetFilterSearch, doSetSortBySearch } from "../../actions/uiAction";
import FilterDropdown from '../PageSearchDetails/FilterDropdown';
import { getQueryParamsUrl } from "../../helpers/url";
import ModalFilterAndSort from '../Modals/ModalFilterAndSort';
import IconFilter from '../../images/filter_icon.png';
import CloseFilter from '../../images/close_icon.png';
import SelectedFilter from '../PageSearchDetails/SelectedFilter';
import { ASSET_IMAGE, RESOURCE_URL } from '../../config';
import { Banner, Content } from '../../Container/Assets';

const PER_PAGE_DEFAULT = 52;

const BROWSE_ALL_KEYWORD = "BROWSE+ALL";

const isBrowseAll = keyword => {
  if (keyword === undefined) return true;
  return keyword.trim().toUpperCase() === BROWSE_ALL_KEYWORD;
};

const CardNotFound = () => (
  <Container className="page-container" style={{ display: "flex" }}>
    <div style={{ flex: 1 }}>
      <div className="not-found" style={{ margin: "0 auto" }}>
        <div className="img-wrapper">
          <KickImage src={NotFoundImg} />
        </div>
        <div className="button-wrapper">
          <Button href="/" className="btn-black flat spacer">
            Back to Home Page
          </Button>
        </div>
        {/* <h1 className="text-center">Mohon Maaf!</h1>
            <h5 className="text-center">Sneaker tidak ditemukan. Hubungi kami di Whatsapp untuk request produk baru.</h5> */}
      </div>
    </div>
  </Container>
);

class PageSearchDetailsTPO extends React.Component {
  constructor(props) {
    super(props);

    const isPreVerified = this.props.location.search.includes(
      "pre_verified=true"
    )
      ? true
      : "";

    const selectedCategory = categorySearch(this.props.match.params.category);
    const isCollectionPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/collection') 
    const isHotProductsPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/hot-products')
    const isMostPopularPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/most-popular')
    const isBestSellingPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/best-selling')

    this.state = {
      isLoading: true,
      page: 1,
      // intervalId: null,
      isVisible: false,
      keyword_search: "",
      openSearch: false,
      hasMore: true,
      prevY: null,
      // bufferY: 0,
      isSearchOpen: false,
      isPreVerified,
      searchCategory: selectedCategory,
      isFilterCollapse: false,

      leftOpen: false,
      rightOpen: true,

      //filter and sort
      sortOpen: false,
      filterOpen: false,
      modal: false,
      currentSort: isCollectionPage ? 'LATEST' : 'MOST_POPULAR',
      isBrandExpanded: false,
      isChildBrandExpanded: false,
      isSizeExpanded: false,
      isConditionExpanded: false,
      isPriceExpanded: false,
      activeSize: 'maleSizes',
      activeApparelsSize: 'topSizes',
      selectedBrands: [],
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: []
      },
      sneakers_condition: '',
      startPrice: '',
      endPrice: '',
      alreadySorted: false,
      sex: '',
      typeFilter: "SEARCH_PRODUCT",
      color: '',

      //collection page
      pageCollection: 1,
      collectionPrevY: 0,
      loadingCollection: true,
      hasMoreCollection: true,
      isCollectionPage: isCollectionPage,
      sizeParams: {
        sizeId: "",
        size_types: "",
        sizes: ""
      },

      //hot products
      isHotProductsPage: isHotProductsPage,
      pageHotProducts: 1,
      prevYHotProducts: 0,
      loadingHotProducts: true,
      hasMoreHotProducts: true,

      //most popular
      pageMostPopular: 1,
      prevYMostPopular: 0,
      loadingMostPopular: true,
      hasMoreMostPopular: true,
      isMostPopularPage: isMostPopularPage,
      isBestSellingPage: isBestSellingPage
    };
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this._scrollToTop = this._scrollToTop.bind(this);
    this._handleScrolling = this._handleScrolling.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleMappingSearchResult = this.handleMappingSearchResult.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);

    //filter and sort
    this.toggleModalSearch = this.toggleModalSearch.bind(this);
    this._handleSorting = this._handleSorting.bind(this);
  }

  async componentDidUpdate(prevProps) {
    const { isPreVerified, searchCategory } = this.state;

    let {
      searchKeyword = "",
      isSearchResultPending,
      stillPending,
      isSearchOpen,
      caseSorting
    } = this.props.dataProduct;
    const { selected } = this.props.dataCategory;

    if (
      prevProps.dataProduct.isSearchResultPending !== isSearchResultPending &&
      !this.state.openSearch &&
      !isSearchResultPending
    )
      this.setState({ openSearch: !this.state.openSearch });

    if (
      prevProps.dataProduct.searchKeyword !== this.props.dataProduct.searchKeyword
    ) {
      const { keyword } = this.props.computedMatch.params;
      const _isBrowseAll = isBrowseAll(keyword);
      const keywordSearch = keyword
        ? keyword
          .toUpperCase()
          .replace(/\+/g, " ")
          .trim()
        : "";

      this.setState({
        keyword_search: _isBrowseAll ? "" : keywordSearch,
        // keyword_search: searchKeyword.toUpperCase() === 'BROWSE ALL'? '': searchKeyword.toUpperCase().replace(/\+/g, ' ').trim(),
        openSearch: true
      });
    }

    // if(prevProps.dataCategory.selected!==this.props.dataCategory.selected){
    //   this.setState({
    //     keyword_search: searchKeyword.toUpperCase() === 'BROWSE ALL'? '': searchKeyword,
    //     openSearch: true
    //   }, ()=>{
    //     const payload = {
    //       searchKeyword: this.state.keyword_search,
    //       category: selected
    //     }
    //     this.props.searchProduct(payload);
    //   })
    // }

    //HIT FILTER/SEARCH API WHEN URL IS CHANGED
    if (
      ((prevProps.match.url !== this.props.match.url && this.props.match.url) ||
        prevProps.location.search !== this.props.location.search) &&
      !stillPending
    ) {
      const params = this.getQueryParamsUrl();
      let keyword = params && params.keyword ? params.keyword : "";
      let searchKeywordFilter = keyword === undefined ? "BROWSE ALL"
        : keyword
          .toUpperCase()
          .replace(/\+/g, " ")
          .trim();
      const { search } = this.props.location;
      const _isBrowseAll = isBrowseAll(keyword);
      if (_isBrowseAll) {
        if (search !== "") {
          let queries = this.getQueryParamsUrl();
          if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' && 
            queries.hasOwnProperty('start_price') || 
            queries.hasOwnProperty('end_price')) {
              
              queries.start_price = this.dolarToRupiah(queries.start_price)
              queries.end_price = this.dolarToRupiah(queries.end_price)
          }
          this.props.doFilteringSearchToApi("", {
            params: {
              ...queries,
              availables: true,
              category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
              per_page: PER_PAGE_DEFAULT,
              sort_by: caseSorting
            }
          });
        } else {
          const payload = {
            params: {
              page: 1,
              availables: true,
              category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
              per_page: PER_PAGE_DEFAULT,
              sort_by: caseSorting
            }
          };
          this.props.doBrowseAll(payload);
        }
      } else {
        if (search !== "") {
          let queries = this.getQueryParamsUrl();
          if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' && 
            queries.hasOwnProperty('start_price') || 
            queries.hasOwnProperty('end_price')) {
              
              queries.start_price = this.dolarToRupiah(queries.start_price)
              queries.end_price = this.dolarToRupiah(queries.end_price)
          }

          this.props.doFilteringSearchToApi("", {
            params: {
              ...queries,
              category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
              keyword: searchKeywordFilter,
              availables: true,
              per_page: PER_PAGE_DEFAULT,
              sort_by: caseSorting
            }
          });
        } else {

          keyword = keyword
            .toUpperCase()
            .replace(/\+/g, " ")
            .trim();
          const payload = {
            searchKeyword: keyword.toLowerCase(),
            category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
            sort_by: caseSorting
          };
          let params = {};

          if (isPreVerified) {
            params = {
              pre_verified: isPreVerified
            };
          }

          this.props.searchProduct(payload);
        }
      }
    }
    // if(!prevProps.dataProduct.isSearchResultPending && prevProps.dataProduct.isSearchResultPending !== this.props.dataProduct.isSearchResultPending){
    //   const  { page } = this.state;
    //   // console.log("TEST ", document.getElementById('product').offsetTop, page)
    //   // const offsetTop = document.getElementById('product').offsetTop;
    //   if(page === 1) {
    //     this._scrollToTop();
    //   }
    // }

    if (prevProps.location !== this.props.location) this._scrollToTop();

    if (
      prevProps.dataProduct.isSearchResultPending &&
      prevProps.dataProduct.isSearchResultPending !==
      this.props.dataProduct.isSearchResultPending
    ) {
      const { pagination, isSearchResultPending } = this.props.dataProduct;
      const currentPage = pagination ? pagination.current_page : 1;
      await this.setState({
        hasMore: pagination ? pagination.next_page !== null : false,
        isLoading: isSearchResultPending,
        page: currentPage,
        prevY: currentPage === 1 ? null : this.state.prevY
      });
      // const offsetTop = document.getElementById('product').offsetTop;
      const { page } = this.state;
      if (page === 1) {
        this._scrollToTop();
      } else {
        // if(page !== 1){
        const offsetTop = document.getElementById("product").offsetTop;
        const height = this.state.productScrollHeight;
        this._scrollToTop(height + 100);
      }
      this.props.hideLoading();
    }

    // console.log(this.state.keyword_search, '=============')
    // if(prevProps.dataProduct.isSearchOpen!=isSearchOpen&&!isSearchOpen||prevProps.dataProduct.isSearchOpen==isSearchOpen){
    //   this.setState({isSearchOpen:!this.state.isSearchOpen});
    // }

    //filter and sort
    // const { selected } = this.props.dataCategory;
    if (prevProps.dataCategory.selected != selected) {
      const query = { params: { category: selected } }
      this.setState({
        filterOpen: false,
        selectedBrands: [],
        selectedSizes: {
          maleSizes: [],
          femaleSizes: [],
          kidSizes: []
        }
      }, () => {
        // this.props.getAllBrands(query);
        // this.props.getAllSizes(query);
        this.props.getPopularSearch(query);
      });
    }

    // Handler for UI sort dropdown
    // By default there are only 2 condition for sorting: most popular and best match
    if (prevProps.isSortOpen !== this.props.isSortOpen && this.props.isSortOpen) {
      // if (!this.state.alreadySorted) {
      //   const params = getQueryParamsUrl(this.props.history.location);
      //   const arrParams = params.pathname.split('/');
      //   this.setState({
      //     // currentSort: arrParams[arrParams.length - 1] === 'browse+all' ? 'MOST_POPULAR' : '',
      //     currentSort: "MOST_POPULAR",
      //     alreadySorted: true,
      //   });
      // } else {
      const { isCollectionPage } = this.state;
      const { caseSorting } = this.props.dataProduct;
      // let sort = caseSorting === "" ? '' : caseSorting;

      const arr = [
        { label: 'FEATURED', value: 'featured' },
        { label: 'MOST_POPULAR', value: 'most_popular' },
        { label: 'BEST_MATCH', value: '' },
        { label: 'MIN_MAX', value: 'price_asc' },
        { label: 'MAX_MIN', value: 'price_desc' },
        { label: 'LATEST', value: '' },
      ]

      const productSort = arr.find(item => item.value === caseSorting);
      const sortUpdated = isCollectionPage ? this.state.currentSort : productSort.label

      this.setState({
        currentSort: sortUpdated
      });
      // }
    }

    //collection page
    if (prevProps.dataCollection.isFetching !== this.props.dataCollection.isFetching) {
      const { status_code, products } = this.props.dataCollection;
      const { pageCollection } = this.state;
      if (status_code === 200) {
        this.getProductList();
      }
    }

    if (prevProps.dataCollection.products.isFetching !== this.props.dataCollection.products.isFetching) {
      const { status_code, products } = this.props.dataCollection;
      const { pageCollection } = this.state;

      if (products.status_code === 200) {
        this.setState({ page: pageCollection + 1 })
      }
    }

    if (prevProps.location.search !== this.props.location.search) {
      const params = getQueryParamsUrl(this.props.history.location.search);
      const { category } = this.props.match.params;

      this.setState({
        // color: params.color ? params.color : "",
        // brands: params.brands ? params.brands : "",
        // sneakers_condition: params.sneakersCondition ? params.sneakersCondition : "",
        // startPrice: params.startPrice ? params.startPrice : "",
        // endPrice: params.endPrice ? params.endPrice : "",
        // sex: params.sex ? params.sex : "",
        // sizesParams: params.sizesParams ? params.sizesParams : "",
        searchCategory: category ? category : ""
      })
    }

    //hot products
    if(prevProps.dataProduct.stillPending && !this.props.dataProduct.stillPending){
      const { pagination } = this.props.dataProduct;
      this.setState({
        hasMoreHotProducts: pagination !== null,
        loadingHotProducts: false
      })
    }
    if(prevProps.dataCategory !== this.props.dataCategory){
      const { dataCategory } = this.props;
      await this.setState({ 
        pageHotProducts: 1, 
        loadingHotProducts: true, 
        hasMoreHotProducts: true, 
        prevYHotProducts: 0 
      });
      this.props.getAdditionalPage('editors-choices', { params: { page: this.state.page, availables: true, category: dataCategory }});
    }

    //most popular
    if(prevProps.dataTopSelling.isFetching && !this.props.dataTopSelling.isFetching){
      const { pagination, hasMoreData } = this.props.dataTopSelling;
      this.setState({
        hasMoreMostPopular: hasMoreData !== null,
        loadingMostPopular: false
      })
    }
    if(prevProps.dataCategory !== this.props.dataCategory){
      const { dataCategory } = this.props;
      await this.setState({ 
        pageMostPopular: 1, 
        loadingMostPopular: true, 
        hasMoreMostPopular: true, 
        prevYMostPopular: 0 
      });
      this.getProductList();
    }
  }

  componentWillUnmount() {
    //filter and sort
    // document.removeEventListener('mousedown', this.handleClickOutside);
    //end filter and sort


    // if(this.state.intervalId){
    //   clearInterval(this.state.intervalId);
    // }
    document.removeEventListener("scroll", this._handleScrolling);
  }

  _isOnTop = buffer => window.pageYOffset + buffer <= buffer;

  getQueryParamsUrl() {
    const checker = new URLSearchParams(this.props.location.search);
    let objParams = {};
    for (let pair of checker.entries()) {
      objParams = {
        ...objParams,
        [pair[0]]: pair[1]
      };
    }
    return objParams;
  }

  dolarToRupiah = (price = 0) => {
    if (!price) {
      return 0
    }
    return Math.round(parseFloat(price) / this.props.dataAuth.userCurrency.ratio)
  }

  componentDidMount() {
    const { searchCategory, isHotProductsPage } = this.state;
    document.addEventListener("scroll", this._handleScrolling);

    const { dataProduct, dataCategory, dataAuth } = this.props;
    const { searchKeyword, stillPending, isSearchResultPending, caseSorting } = dataProduct;

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.7
    };
    const isInfiniteScrolL = !isFromAppBrowser();
    this.setState({ isInfiniteScrolL });
    if (isInfiniteScrolL) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserver.bind(this), // pass the callback
        options
      );
      IntersectionObserver.prototype.POLL_INTERVAL = 100;
      this.observer.USE_MUTATION_OBSERVER = true;
      this.observer.observe(this.loadingRef);
    }

    if (dataAuth.isLogged) {
      this.props.fetchProfile().then((res) => {
        try {
          let code = res.value.data.country_code
          const currencyCode = CURRENCY_CODE[code === 'IDN' ? 'IDN' : 'ETC'];
          this.props.fetchCurrencyRate(currencyCode)
        } catch (error) {
          this.props.fetchCurrencyRate(CURRENCY_CODE['IDN'])
        }
      });
    }

    const params = this.getQueryParamsUrl();
    let keyword = params && params.keyword ? params.keyword : "";

    let searchKeywordFilter = keyword === undefined ? "BROWSE ALL"
      : keyword
        .toUpperCase()
        .replace(/\+/g, " ")
        .trim();
    const { search } = this.props.location;
    const _isBrowseAll = isBrowseAll(keyword);
    keyword = keyword
      ? keyword
        .toUpperCase()
        .replace(/\+/g, " ")
        .trim()
      : "";
    this.setState({
      openSearch: true,
      keyword_search: _isBrowseAll ? "" : keyword,
      searchCategory: ""
    });

    const queries = getQueryParamsUrl(this.props.history.location.search);

    const selectedCategory = categorySearch(this.props.match.params.category);

    this.setState({
      color: queries.colours ? queries.colours : "",
      brands: queries.brands ? queries.brands : "",
      sneakers_condition: queries.sneakersCondition ? queries.sneakersCondition : "",
      startPrice: queries.startPrice ? queries.startPrice : "",
      endPrice: queries.endPrice ? queries.endPrice : "",
      sex: queries.sex ? queries.sex : "",
      keyword_search: queries.keyword ? queries.keyword : "",
      searchCategory: selectedCategory ? selectedCategory : "",
      sizeParams: {
        sizeId: this.state.sizeId,
        size_types: this.state.size_types,
        sizes: this.state.sizes
      }
    })

    const query = { params: { category: searchCategory } }
    this.setState({
      filterOpen: false,
      selectedBrands: [],
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: []
      }
    }, () => {
      this.props.getAllBrands(query);
      this.props.getAllSizes(query);
      // this.props.getPopularSearch(query);
    });

    //collection page
    const { isCollectionPage } = this.state;
    const { computedMatch: { params: { category, slug } } } = this.props;

    if (isCollectionPage) {
      this.props.getCollectionBySlug(category, slug);

      this.observer = new IntersectionObserver(
        this.handleObserverCollection.bind(this),
        options
      );
      this.observer.observe(this.loadingRef);
    } else {
      if (!stillPending && !isSearchResultPending) {
        if (_isBrowseAll) {
          if (search !== "") {
            let queries = this.getQueryParamsUrl();
            if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' && 
              queries.hasOwnProperty('start_price') || 
              queries.hasOwnProperty('end_price')) {
                
                queries.start_price = this.dolarToRupiah(queries.start_price)
                queries.end_price = this.dolarToRupiah(queries.end_price)
            }
            this.props.doFilteringSearchToApi("", {
              params: {
                ...queries,
                category:
                  searchCategory === "bcaxkickavenue"
                    ? ""
                    : searchCategory,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            });
          } else {
            this.setState({
              searchCategory: searchCategory === "bcaxkickavenue"
                ? ""
                : searchCategory
            })
            const payload = {
              params: {
                page: 1,
                availables: true,
                category:
                  searchCategory === "bcaxkickavenue"
                    ? ""
                    : searchCategory,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            };
            this.props.doBrowseAll(payload);
          }
        } else {
          if (search !== "") {
            let queries = this.getQueryParamsUrl();
            if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' && 
              queries.hasOwnProperty('start_price') || 
              queries.hasOwnProperty('end_price')) {
                
                queries.start_price = this.dolarToRupiah(queries.start_price)
                queries.end_price = this.dolarToRupiah(queries.end_price)
            }
            this.props.doFilteringSearchToApi("", {
              params: {
                ...queries,
                category:
                  searchCategory === "bcaxkickavenue"
                    ? ""
                    : searchCategory,
                keyword: searchKeywordFilter,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            });
          } else {
            // keyword = keyword.toUpperCase().replace(/\+/g, ' ').trim();
            const payload = {
              searchKeyword: keyword,
              category:
                searchCategory === "bcaxkickavenue"
                  ? ""
                  : searchCategory,
              sort_by: caseSorting
            };
            this.props.searchProduct(payload);
          }
        }
        if (
          !this.props.dataPopular.isFetch &&
          this.props.dataPopular.status_code !== 200
        ) {
          const query = { params: { category: searchCategory } };
          this.props.getPopularSearch(query);
        }
      }
    }

    //hot products
    if (isHotProductsPage) {
      this.props.getDetailSection(searchCategory, "editors-pick")
      this.props.getAdditionalPage('editors-choices', { 
        params: { 
          page: this.state.pageHotProducts, 
          availables: true, 
          category: searchCategory 
        }
      });

      let optionsHotProducts = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0
      };
      const isInfiniteScrolLHotProducts = !isFromAppBrowser();
      this.setState({ isInfiniteScrolLHotProducts })
      if(isInfiniteScrolLHotProducts) {
        // Create an observer instance
        this.observer = new IntersectionObserver(
          this.handleObserverHotProducts.bind(this), // pass the callback
          optionsHotProducts
        );
        this.observer.observe(this.loadingRef);
      }
    } else {
      let paramCheck = this.props.location.pathname.includes("most-popular")
      let section = paramCheck ? "trending-now" : "top-selling"

      this.props.getDetailSection(searchCategory, section)

      let optionsMostPopular = {
        root: null, 
        rootMargin: '0px',
        threshold: 0.7
      };
      const isInfiniteScrolLMostPopular = !isFromAppBrowser();
      this.setState({ isInfiniteScrolLMostPopular })
      this.getProductListMostPopular();
      if(isInfiniteScrolLMostPopular) {
        // Create an observer instance
        this.observer = new IntersectionObserver(
          this.handleObserverMostPopular.bind(this), // pass the callback
          optionsMostPopular
        );
        this.observer.observe(this.loadingRef);
      }
    }
  }

  fetchHotProducts = () => {
    const { searchCategory } = this.state;

    this.props.getDetailSection(searchCategory, "editors-pick")
    this.props.getAdditionalPage('editors-choices', { 
      params: { 
        page: this.state.pageHotProducts, 
        availables: true, 
        category: searchCategory 
      }
    });

    this.props.history.push({
      pathname: `${searchCategory}/hot-products`
    })

    let optionsHotProducts = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0
    };
    const isInfiniteScrolLHotProducts = !isFromAppBrowser();
    this.setState({ isInfiniteScrolLHotProducts })
    if(isInfiniteScrolLHotProducts) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserverHotProducts.bind(this), // pass the callback
        optionsHotProducts
      );
      this.observer.observe(this.loadingRef);
    }
  }

  fetchMostPopular = () => {
    const { searchCategory } = this.state;

    let paramCheck = this.props.location.pathname.includes("most-popular")
    let section = paramCheck ? "trending-now" : "top-selling"

    this.props.getDetailSection(searchCategory, section)

    this.props.history.push({
      pathname: paramCheck ? `${searchCategory}/most-popular` : `${searchCategory}/best-selling`
    })

    let optionsMostPopular = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.7
    };
    const isInfiniteScrolLMostPopular = !isFromAppBrowser();
    this.setState({ isInfiniteScrolLMostPopular })
    this.getProductListMostPopular();
    if(isInfiniteScrolLMostPopular) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserverMostPopular.bind(this), // pass the callback
        optionsMostPopular
      );
      this.observer.observe(this.loadingRef);
    }
  }

  async handleObserver(entities, observer) {
    const y = entities[0].boundingClientRect.y;
    if (this.state.prevY === null)
      await this.setState({
        prevY: y,
        productScrollHeight:
          this.productContainerRef && this.productContainerRef.scrollHeight
      });
    if (
      !this.props.dataProduct.isSearchResultPending &&
      this.state.hasMore &&
      !this.state.isLoading
    ) {
      if (this.state.prevY >= y) {
        // await this.setState({ page: this.state.page, isLoading: true })
        await this.handleLoadMore();
      }
      this.setState({
        prevY: y,
        productScrollHeight: this.productContainerRef && this.productContainerRef.scrollHeight
      });
    }
  }

  _handleNextPageClick = async () => {
    await this.setState({
      productScrollHeight: this.productContainerRef && this.productContainerRef.scrollHeight
    });
    await this.handleLoadMore();
  };

  handlePrice(price) {
    if (price === null) {
      return <p style={{ paddingTop: "5px" }}>Out of Stock</p>;
    } else {
      return (
        <div>
          <p style={{ paddingBottom: "5px", paddingTop: "5px" }}>Harga dari</p>
          <p>IDR. {convertToRupiah(Number(price.asking_price))}</p>
        </div>
      );
    }
  }

  async handleLoadMore() {
    const { searchCategory } = this.state;
    const {
      searchKeyword,
      isFiltering,
      caseSorting
      // pagination:{ current_page }
    } = this.props.dataProduct;

    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";

    let searchKeywordFilter = keyword === undefined ? "BROWSE+ALL"
      : keyword
        .toUpperCase()
        .replace(/\+/g, " ")
        .trim();
    const { search } = this.props.location;
    // let params = search.slice(1);
    await this.setState({
      page: this.state.page + 1,
      isLoading: true
    });
    const _isBrowseAll = isBrowseAll(keyword);
    const { page } = this.state;
    if (_isBrowseAll) {
      if (search !== "") {
        let queries = this.getQueryParamsUrl();
        if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' && 
          queries.hasOwnProperty('start_price') || 
          queries.hasOwnProperty('end_price')) {
            
            queries.start_price = this.dolarToRupiah(queries.start_price)
            queries.end_price = this.dolarToRupiah(queries.end_price)
        }
        if (caseSorting !== "") {
          this.props.sortingSearchResultAPI(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                sort_by: caseSorting,
                page,
                availables: true,
                per_page: PER_PAGE_DEFAULT
              }
            },
            "LOAD_MORE"
          );
        } else {
          this.props.doFilteringSearchToApi(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                page,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            },
            "LOAD_MORE"
          );
        }
      } else {
        // console.log("BROWSE ALL WHEN url/search no media queries");
        if (caseSorting !== "") {
          this.props.sortingSearchResultAPI(
            "",
            {
              params: {
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                sort_by: caseSorting,
                page,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
              }
            },
            "LOAD_MORE"
          );
        } else {
          const payload = {
            params: {
              page: page,
              availables: true,
              category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
              per_page: PER_PAGE_DEFAULT,
              sort_by: caseSorting
            }
          };
          this.props.doBrowseAll(payload, "LOAD_MORE");
        }
      }
    } else {
      if (search !== "") {
        let queries = this.getQueryParamsUrl();
        if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' && 
          queries.hasOwnProperty('start_price') || 
          queries.hasOwnProperty('end_price')) {
            
            queries.start_price = this.dolarToRupiah(queries.start_price)
            queries.end_price = this.dolarToRupiah(queries.end_price)
        }
        if (caseSorting !== "") {
          this.props.sortingSearchResultAPI(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                sort_by: caseSorting,
                page,
                keyword: searchKeywordFilter,
                availables: true,
                per_page: PER_PAGE_DEFAULT
              }
            },
            "LOAD_MORE"
          );
        } else {
          this.props.doFilteringSearchToApi(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                page,
                keyword: searchKeywordFilter,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            },
            "LOAD_MORE"
          );
        }
      } else {
        const params = {
          keyword: searchKeywordFilter,
          sort_by: caseSorting,
          category: searchCategory === "harbolnas" ? "" : searchCategory,
          per_page: PER_PAGE_DEFAULT,
          page
        };
        this.props.searchToLoadMore(params);
      }
    }
  }

  checkingSearchResult() {
    const { dataProduct } = this.props;
    const { isPreVerified, searchCategory } = this.state;

    if (dataProduct.isSearchResultPending && this.state.page === 1) {
      return <CardLoading />;
    } else if (
      dataProduct.searchResult.length > 0 &&
      (dataProduct.errorMessageSearch === "Sneaker ditemukan" ||
        dataProduct.errorMessageSearch === "Tidak Ada pilihan" ||
        dataProduct.errorMessageSearch === "Hasil telah ditemukan")
    ) {
      return (
        <Row
          className="result-search"
          style={{
            minHeight: 500,
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "row",
            marginTop: "1rem"
          }}
        >
          {dataProduct.searchResult.map((item, index) => {
            const brandSlug = convertBrandNameToSlug(item.brands?.[0]);
            Object.assign(item, { brandSlug });
            return (
              <Sneaker
                {...item}
                key={index}
                searchCategory={searchCategory}
                updateActiveId={this.props.updateActiveId}
                activeId={this.props.activeId}
                isPreVerified={isPreVerified}
              />
            );
          })}
        </Row>
      );
    } else {
      if (
        dataProduct.isSearchResultPending &&
        dataProduct.errorMessageSearch === ""
      )
        return <CardLoading />;
      else if (
        dataProduct.searchResult.length === 0 || dataProduct.errorMessageSearch === "Sneaker tidak tersedia!" ||
        dataProduct.errorMessageSearch === "Not Found"
      )
        return <CardNotFound />;
    }
  }

  handleSearchCounter(pagination) {
    const { errorMessageSearch } = this.props.dataProduct;
    if (pagination !== null) {
      if (errorMessageSearch === "Not Found") {
        return 0;
      } else {
        return pagination.total;
      }
    } else {
      return 0;
    }
  }

  renderKeywordSearch() {
    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";

    if (keyword === undefined) {
      return "Browse All";
    } else if (this.props.location.search == "?&sneakers_condition=new") {
      return "Kondisi Baru";
    } else if (this.props.location.search == "?&sneakers_condition=used") {
      return "Kondisi Bekas";
    } else if (this.props.location.search == "?&sneakers_condition=pre_order") {
      return "Kondisi PRE-ORDER";
    } else {
      return keyword.toUpperCase();
    }
  }

  /*
  render Counter hasil searching dan Filter
  */
  _renderSearchSummary() {
    // console.log('THIS PROPS ', this.props);
    const {
      searchKeyword,
      searchResult,
      redirectSearch,
      searchResultTmp,
      isFiltering,
      pagination,
      totalFilter
    } = this.props.dataProduct;
    const counterSearch =
      isFiltering === true ? searchResultTmp.length : searchResult.length;
    return (
      <Container className="page-container">
        <Row className="d-none">
          <div className="counter__search">
            <h3>Hasil Pencarian: </h3>
            <h3 className="search__keyword">'{this.renderKeywordSearch()}'</h3>
            {/* <h3 className="search__counter">({this.handleSearchCounter(pagination)})</h3> */}
          </div>
        </Row>
        {isFiltering === true ? (
          <Row className="d-none">
            <div className="counter__search">
              {/* <h3>Hasil Filter: </h3>
              <h3 className="search__counter">({ totalFilter  })</h3> */}
            </div>
          </Row>
        ) : null}
      </Container>
    );
  }

  handleClick(e) {
    e.preventDefault();
    this.setState({
      keyword_search: e.target.textContent
    });
  }

  setFocus() {
    this.searchInput.focus();
  }

  renderInitialPopular() {
    return (
      <div className="initial-popular">
        <Row style={{ marginTop: "1rem" }}>
          <Col
            lg="4"
            md="2"
            sm="4"
            xs="12"
            className="wrapper-popular-keywords"
          >
            {!this.props.dataPopular.hasOwnProperty("data") ? null : (
              <p className="popular-search popular">Popular keywords: </p>
            )}
          </Col>
          {/* <Col md="7"> */}
          {!this.props.dataPopular.hasOwnProperty("data")
            ? null
            : this.props.dataPopular.data.map((shoe, index) => (
              <Col
                lg="1"
                md="2"
                sm="8"
                xs="6"
                key={index}
                className="wrapper-popular-search"
              >
                <p
                  key={shoe.id}
                  className="popular-search"
                  onClick={this.handleClick}
                  style={{ fontSize: "12px", color: "#4a4a4a" }}
                >
                  {shoe.query}
                </p>
              </Col>
            ))}
          {/* </Col> */}
        </Row>
      </div>
    );
  }

  handleMappingSearchResult() {
    return this.renderInitialPopular();
  }

  onChange(e) {
    // this.setState({
    //  [e.target.name]: e.target.value
    // }, () => {
    //  if (this.state.keyword_search.length > 2) {
    //      _.delay(() => {
    //          this.props.searchProduct(this.state.keyword_search.toUpperCase())
    //      }, 2000, 'later')
    //  }
    // });
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleButtonSearch = async () => {
    await this.setState({
      page: 1
    });
    const { searchCategory } = this.state;
    const { dataAuth, dataCategory } = this.props;
    const userId = dataAuth.isLogged ? dataAuth.userdata.id : null;
    const searchQuery = this.state.keyword_search.replace(/\+/g, " ").toUpperCase();
    const category = searchCategory;
    let dataSearch = {
      user_id: userId,
      query: searchQuery,
      category
    };

    let params =
      this.state.keyword_search === ""
        ? "Browse All"
        : this.state.keyword_search;
    let manipulate = this.state.keyword_search
      .trim()
      .split(" ")
      .join("+");
    this.props.history.push(
      `/search/${searchCategory}/${params
        .trim()
        .split(" ")
        .join("+")
        .toLowerCase()}`
    );
    const payload = {
      searchKeyword: manipulate.toUpperCase(),
      category: searchCategory
    };
    this.props.searchProduct(payload);
    if (
      this.state.keyword_search !== "" &&
      searchCategory !== "bcaxkickavenue"
    ) {
      this.props.saveSearchQueries(dataSearch);
      Analytics.recordSearch(
        userId,
        searchQuery,
        category
      )
    }
  };

  openSearch() {
    this.setState({
      openSearch: !this.state.openSearch
    });
  }

  handleClear() {
    this.setState({
      keyword_search: ""
    });
  }

  // _renderSearchBox() {
  //   const {
  //     dataProduct,
  //     dataCategory: { selected }
  //   } = this.props;
  //   const { searchKeyword } = dataProduct;
  //   const searchWord = this.props.computedMatch.params.keyword && this.props.computedMatch.params.keyword.toUpperCase().replace(/\+/g, " ").trim();
  //   const notFound = dataProduct.searchResult.length === 0 || dataProduct.errorMessageSearch === "Sneaker tidak tersedia!" ||
  //   dataProduct.errorMessageSearch === "Not Found"

  //   return (
  //     <div className={classNames("search-result__text", {"d-block d-sm-none": notFound})}>
  //       {this.state.keyword_search !== "" ? (
  //         <span>SEARCH RESULT FOR '{searchWord}'</span>
  //       ) : this.props.location.search.includes("?sneakers_condition=used") ? (
  //         <span>PRE-OWNED PRODUCT</span>
  //       ) : (
  //         <span>ALL PRODUCTS</span>
  //       )}
  //     </div>
  //   );
  // }

  _handleScrolling() {
    const { scrollY, innerHeight } = window;
    // console.log('scrollY -->', scrollY);
    if (scrollY >= innerHeight / 3 && !this.state.isVisible) {
      this.setState({
        isVisible: !this.state.isVisible
      });
    } else if (scrollY < innerHeight / 3 && this.state.isVisible) {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }
  }

  _scrollToTop(bufferY = 0) {
    this.props.clientScroll.scrollYAnimated(bufferY);
  }

  toggleSidebar = () => {
    this.setState({ leftOpen: !this.state.leftOpen });
  }

  //filter and sort
  toggle = () => {
    this.props.setSortBy(!this.props.isSortOpen);
  }

  /**
     * Alert if clicked on outside of element
     */
  //  handleClickOutside = (event) => {
  //   if (this.filterWrapperRef.current && !this.filterWrapperRef.current.contains(event.target)) {
  //     if (this.props.isFilterOpen) {
  //       this.props.setFilter(!this.props.isFilterOpen);
  //     }
  //   }
  //   if (this.sortWrapperRef.current && !this.sortWrapperRef.current.contains(event.target)) {
  //     if (this.props.isSortOpen) {
  //       this.props.setSortBy(!this.props.isSortOpen);
  //     }
  //   }
  // }

  toggleFilter = () => {
    if (this.props.isFilterOpen == false) {
      const query = {
        params: { category: this.state.searchCategory }
      }
      // this.props.getAllBrands(query)
      // this.props.getAllSizes(query)
    }
    this.props.setFilter(!this.props.isFilterOpen);
  }

  _handleSorting(caseSort, sort_params) {
    const { searchCategory, isCollectionPage } = this.state;
    const { search } = this.props.history.location;
    let paramsRoute = search !== '' ? search.slice(1) : '';
    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";
    let searchKeywordFilter = keyword === undefined ? '' : keyword.toUpperCase().replace(/\+/g, ' ').trim();

    //collection page
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;
    const { selected } = this.props.dataCategory;

    if (isCollectionPage) {
      let filterQueries = '';
      const payloadProduct = {
        page: 1,
        availables: true,
        collection: slug,
        collection_type: collectionType,
        category: selected,
        sort_by: sort_params
      }
      this.props.fetchCollectionProduct(payloadProduct, filterQueries)
    } else {
      if (this.state.typeFilter === 'NEVER_TOO_LAVISH') {
        this.props.sortingSearchResultAPI(paramsRoute, {
          params: {
            collection: 'never-too-lavish',
            category: searchCategory,
            sort_by: sort_params,
            page: 1,
            per_page: 52,
            availables: true
          }
        }, '');
      } else {
        if (searchKeywordFilter.toUpperCase() === 'BROWSE ALL' || searchKeywordFilter.toUpperCase() === 'BROWSE+ALL') {
          // console.log('KOSONG')
          this.props.sortingSearchResultAPI(paramsRoute, {
            params: {
              sort_by: sort_params,
              category: searchCategory,
              page: 1,
              per_page: 52,
              availables: true
            }
          }, '');
        } else {
          // console.log('ISI')
          this.props.sortingSearchResultAPI(paramsRoute, {
            params: {
              sort_by: sort_params,
              category: searchCategory,
              keyword: searchKeywordFilter,
              page: 1,
              per_page: 52,
              availables: true
            }
          }, '');
        }
      }
    }

    if (this.props.onResetPageNumber) this.props.onResetPageNumber()
  }

  renderSortDropdown() {
    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";
    let searchKeywordFilter = keyword === undefined ? 'BROWSE ALL' : keyword.toUpperCase().replace(/\+/g, ' ').trim();
    const { search } = this.props.history.location;
    const { currentSort, isCollectionPage } = this.state;

    return (
      <div ref={this.sortWrapperRef} id={'filter-sort'} className="container__drop_down show__option sort__dropdown__wrapper">
        {
          !isCollectionPage &&
          <>
            <div className="wrapping__btn btn-sort items__show">
              <Button
                style={{ fontFamily: currentSort === 'MOST_POPULAR' ? "Nunito-Bold" : "Nunito-Regular" }}
                onClick={() => {
                  this.setState({
                    currentSort: 'MOST_POPULAR'
                  })
                  this._handleSorting('MOST_POPULAR', 'most_popular')
                  this.toggle()
                }}
              >Most Popular</Button>
            </div>
            <div className="wrapping__btn btn-sort items__show">
              <Button
                style={{ fontFamily: currentSort === "BEST_MATCH" ? "Nunito-Bold" : "Nunito-Regular" }}
                onClick={() => {
                  this.setState({
                    currentSort: "BEST_MATCH"
                  })
                  this._handleSorting("BEST_MATCH", "")
                  this.toggle()
                }}
              >Best Match</Button>
            </div>
          </>
        }
        {
          isCollectionPage &&
          <div className="wrapping__btn btn-sort items__show">
            <Button
              style={{ fontFamily: currentSort === 'LATEST' ? "Nunito-Bold" : "Nunito-Regular" }}
              onClick={() => {
                this.setState({
                  currentSort: 'LATEST'
                })
                this._handleSorting('LATEST', '')
                this.toggle()
              }}
            >Latest</Button>
          </div>
        }
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'MAX_MIN' ? "Nunito-Bold" : "Nunito-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'MAX_MIN'
              })
              this._handleSorting('MAX_MIN', 'price_desc')
              this.toggle()
            }}
          >Highest to Lowest</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'MIN_MAX' ? "Nunito-Bold" : "Nunito-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'MIN_MAX'
              })
              this._handleSorting('MIN_MAX', 'price_asc')
              this.toggle()
            }}
          >Lowest to Highest</Button>
        </div>
      </div>
    )
  }



  toggleModalSearch() {
    if (this.state.modal == false) {
      // this.props.getAllBrands()
      // this.props.getAllSizes()
    }
    this.setState({
      modal: !this.state.modal
    });

  }

  updateState = (key, val, unselectable = false) => {
    if (!unselectable)
      this.setState({ [key]: val })

    else {
      this.setState({
        [key]: this.state[key] === val ? '' : val //clear if the value is already selected
      })
    }
  }

  onSaveLastState = (activeSize, activeApparelsSize, selectedBrands, selectedSizes, sneakers_condition, startPrice, endPrice, sex, color) => {
    this.setState({
      activeSize,
      activeApparelsSize,
      selectedBrands,
      selectedSizes,
      sneakers_condition,
      startPrice,
      endPrice,
      sex,
      color
    })
  }

  renderFilterDropdown() {
    const { isCollectionPage, isHotProductsPage, isMostPopularPage, isBestSellingPage } = this.state;
    return (
      <div ref={this.filterWrapperRef}>
        <FilterDropdown
          history={this.props.history}
          match={this.props.match}
          onClose={this.toggleFilter}
          updateState={(key, val, unselectable = true) => this.updateState(key, val, unselectable = true)}
          isBrandExpanded={this.state.isBrandExpanded}
          isChildBrandExpanded={this.state.isChildBrandExpanded}
          isSizeExpanded={this.state.isSizeExpanded}
          isConditionExpanded={this.state.isConditionExpanded}
          isPriceExpanded={this.state.isPriceExpanded}
          activeSize={this.state.activeSize}
          activeApparelsSize={this.state.activeApparelsSize}
          selectedBrands={this.state.selectedBrands}
          selectedSizes={this.state.selectedSizes}
          sneakers_condition={this.state.sneakers_condition}
          startPrice={this.state.startPrice}
          endPrice={this.state.endPrice}
          onSaveLastState={this.onSaveLastState}
          dataCategory={this.props.dataCategory}
          isOpen={this.props.isFilterOpen}
          sex={this.state.sex}
          color={this.state.color}
          searchCategory={this.state.searchCategory}
          isCollectionPage={isCollectionPage}
          isHotProductsPage={isHotProductsPage}
          fetchHotProducts={this.fetchHotProducts}
          fetchMostPopular={this.fetchMostPopular}
          isMostPopularPage={isMostPopularPage}
          isBestSellingPage={isBestSellingPage}
        />
      </div>
    )
  }

  calculateSize = () => {
    let { maleSizes, femaleSizes, kidSizes } = this.state.selectedSizes
    let sizes = [...maleSizes, ...femaleSizes, ...kidSizes]
    const sizesTypes = sizes.map(s => s.sex).join(",");

    return sizes.length
      ? `sizes=${sizes.map(s => s.US).join(",")}&size_types=${sizesTypes}`
      : ''
  }

  getSizeIdHelper = () => {
    let { maleSizes, femaleSizes, kidSizes } = this.state.selectedSizes
    let sizes = [...maleSizes, ...femaleSizes, ...kidSizes]

    return sizes.length
      ? `sizeId=${sizes.map(s => s.id).join(",")}`
      : ''
  }

  removeFilter = (key) => {
    const { searchCategory, color, selectedBrands, sneakers_condition, startPrice, endPrice, sex, keyword_search, sizeParams: { sizeId,
      size_types, sizes } } = this.state;
    let { caseSorting, searchKeyword } = this.props.dataProduct;

    const queries = this.getQueryParamsUrl();

    if (typeof key === "object") {
      const arrSizeId = queries && queries.sizeId.split(',')
      const arrSizeTypes = queries && queries.size_types.split(',')
      const arrSizeUs = queries && queries.sizes.split(',')

      const indexValue = arrSizeId.indexOf(`${key.id}`)

      const selectedSizeId = arrSizeId.splice(indexValue, 1)
      const selectedSizeTypes = arrSizeTypes.splice(indexValue, 1)
      const selectedSizeUS = arrSizeUs.splice(indexValue, 1)

      this.setState({
        sizeParams: {
          sizeId: selectedSizeId.toString(),
          size_types: selectedSizeTypes.toString(),
          sizes: selectedSizeUS.toString()
        }
      }, () => {
        const brands = this.state.selectedBrands.join(",");
        const newPath = searchCategory ? `/search/${searchCategory}${this.props.location.search}` : `/search${this.props.location.search}`

        let searchQueries = "";

        //TODO: PLEASE COMPLETE SEARCH QUERIES
        if (key === "keyword") {
          this.props.searchState("")
        } else {
          if (keyword_search) searchQueries += `keyword=${keyword_search}&`
        }
        if (color) searchQueries += `colours=${color}&`
        if (brands) searchQueries += `brands=${brands}&`
        if (sneakers_condition) searchQueries += `sneakers_condition=${sneakers_condition}&`
        if (startPrice) searchQueries += `startPrice=${startPrice}&`
        if (endPrice) searchQueries += `endPrice=${endPrice}&`
        if (sex) searchQueries += `sex=${sex}&`
        if (sizeId) searchQueries += `sizeId=${sizeId}&`
        if (size_types) searchQueries += `size_types=${size_types}&`
        if (sizes) searchQueries += `sizes=${sizes}&`

        //PUSH TO NEW PATH
        this.props.history.push({
          pathname: searchCategory ? `/search/${searchCategory}` : "/search",
          search: searchQueries
        })
      })
    } else {
      this.setState({
        [key]: ""
      }, () => {
        const brands = this.state.selectedBrands.join(",");
        const newPath = searchCategory ? `/search/${searchCategory}${this.props.location.search}` : `/search${this.props.location.search}`
        // let sizesParams = this.calculateSize()

        let searchQueries = "";

        //TODO: PLEASE COMPLETE SEARCH QUERIES
        if (key === "keyword") {
          this.props.searchState("")
        } else {
          if (keyword_search) searchQueries += `keyword=${keyword_search}&`
        }
        if (color) searchQueries += `colours=${color}&`
        if (brands) searchQueries += `brands=${brands}&`
        if (sneakers_condition) searchQueries += `sneakers_condition=${sneakers_condition}&`
        if (startPrice) searchQueries += `startPrice=${startPrice}&`
        if (endPrice) searchQueries += `endPrice=${endPrice}&`
        if (sex) searchQueries += `sex=${sex}&`
        // if (sizesParams) searchQueries += `sizesParams=${sizesParams}&`
        // if (sizesParams) searchQueries += `${this.getSizeIdHelper()}&`

        //PUSH TO NEW PATH
        this.props.history.push({
          pathname: searchCategory ? `/search/${searchCategory}` : "/search",
          search: searchQueries
        })

        //NO NEED TO HIT FILTER/SEARCH API
        // this.props.doFilteringSearchToApi("", {
        //   params: {
        //     ...queries,
        //     availables: true,
        //     category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
        //     per_page: PER_PAGE_DEFAULT,
        //     sort_by: caseSorting
        //   }
        // })
      })
    }

  }

  resetFilter = () => {
    const { caseSorting } = this.props.dataProduct;
    const { isCollectionPage } = this.state;
    const pathname = this.props.location && this.props.location.pathname;
    const search = this.props.location && this.props.location.search;

    this.setState({
      startPrice: "",
      endPrice: "",
      sneakers_condition: "",
      sex: "",
      color: "",
      brands: "",
      sizesParams: ""

    }, () => {
      this.props.doFilteringSearchToApi('', {
        params: {
          page: 1,
          availables: true,
          category: "",
          per_page: PER_PAGE_DEFAULT,
          sort_by: caseSorting
        }
      }, '')
      this.props.history.push({
        pathname: isCollectionPage ? `${pathname}` : '/search',
        search: ''
      })
    })
  }

  /*
    render modal Filter
  */
  renderModalFilter() {
    return (
      <ModalFilterAndSort
        active={this.state.modal}
        toggleModalSearch={this.toggleModalSearch.bind(this)}
        history={this.props.history}
        match={this.props.match}
        typeFilter={this.state.typeFilter}
      />
    )
  }

  currentSort = (sort) => {
    switch (sort) {
      case "MOST_POPULAR":
        return "Most Popular"
      case "BEST_MATCH":
        return "Best Match"
      case "MAX_MIN":
        return "Highest to Lowest"
      case "MIN_MAX":
        return "Lowest to Highest"
      case "LATEST":
        return "Latest"

      default:
        return "Most Popular"
    }
  }


  //collection page
  getProductList = () => {
    // const { dataCategory, dataCollection: { id } } = this.props;
    // const { pageCollection } = this.state;

    const { selected } = this.props.dataCategory;
    const { pathname } = this.props.history.location;
    const { isPreVerified } = this.state;
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;

    let brands = this.state.selectedBrands.join(",")
    let sizesParams = this.calculateSize()
    let { minPrice, maxPrice } = this.state
    let { sneakers_condition } = this.state

    let filterQueries = '';

    const payloadProduct = {
      page: 1,
      availables: true,
      collection: slug,
      collection_type: collectionType,
      category: selected,
      sort_by: caseSorting
    }

    if (isPreVerified) payloadProduct.pre_verified = true

    // const payload = {
    //   pageCollection
    // }

    // this.props.getCollectionProduct(id, payload);
    this.props.fetchCollectionProduct(payloadProduct, filterQueries);
  }

  handleObserverCollection(entities, observer) {
    const { collectionPrevY, pageCollection } = this.state;
    const {
      dataCollection: {
        products: { hasMoreData }
      }
    } = this.props;

    const y = entities[0].boundingClientRect.y;
    if (hasMoreData !== null) {
      if (collectionPrevY > y) {
        this.getProductList();
      }
      this.setState({ collectionPrevY: y });
    }
  }

  renderProducts = () => {
    const { products: { data, isFetching } } = this.props.dataCollection;

    if (data.length === 0) return <CardNotFound />;

    return (
      <div id="product">
        <Row>
          {
            data.map((item, index) => (
              <Sneaker
                hotProducts={item.editors_choice}
                {...item}
                category={this.props.dataCategory}
                key={index}
                outOfStock={item.out_of_stock} />
            ))
          }
        </Row>
      </div>
    )
  }

  renderCollectionPage = () => {
    const { imageLandscape, imagePortrait, products: { isFetching } } = this.props.dataCollection;

    return (
      <div className="product-list">
        {this.renderProducts()}
        <div style={{ marginTop: "120px" }}>
          <SneakerLoadingSpinner
            isLoading={isFetching && this.state.pageCollection > 1}
            isHide={!isFetching}
            wrapperRef={loadingRef => this.loadingRef = loadingRef}
          />
        </div>
      </div>
    )
  }

  //hot products
  _handleNextPageClickHotProducts = async () => {
    if(!this.state.loadingHotProducts && this.state.hasMoreHotProducts){
      // const { dataCategory } = this.props;
      const { searchCategory } = this.state;
      const curPage = this.state.pageHotProducts + 1;
      await this.setState({ pageHotProducts: curPage, loadingHotProducts: true });
      this.props.getAdditionalPage('editors-choices', { params: { page: this.state.pageHotProducts, availables: true, category: searchCategory }});
    }
  }

  handleObserverHotProducts(entities, observer) {
    const { dataProduct: { pagination, stillPending } } = this.props;
    const { searchCategory } = this.state;
    const y = entities[0].boundingClientRect.y;
    if (pagination !== null) {
      if (this.state.prevYHotProducts > y) {
        const curPage = this.state.pageHotProducts + 1;
        this.props.getAdditionalPage('editors-choices', { params: { page: curPage, availables: true, category: searchCategory }});
        this.setState({ pageHotProducts: curPage, loadingHotProducts: true });
      }
      this.setState({ prevYHotProducts: y });
    } else if (pagination === null && this.state.hasMoreHotProducts) {
      if (this.state.pageHotProducts === 1) {
        if (this.state.prevYHotProducts > y) {
          const curPage = this.state.pageHotProducts + 1;
          this.props.getAdditionalPage('editors-choices', { params: { page: curPage, availables: true, category: searchCategory }});
          this.setState({ pageHotProducts: curPage, loadingHotProducts: true });
        }
        this.setState({ prevYHotProducts: y });
      } else {
        this.setState({
          loadingHotProducts: false
        })
      }
    }
  }

  renderHotProducts = () => {
    return (
      <div className="product-list">
        <Content hotProducts={true} />
        {
          !this.state.isInfiniteScrolLHotProducts?
            <div className="d-flex justify-content-center">
              <Button
                block
                size={"lg"}
                type="button"
                onClick={this._handleNextPageClickHotProducts}
                className={classNames('button-load-more browse__all',{'d-none': this.state.loadingHotProducts || !this.state.hasMoreHotProducts})}
              >
                Load More
              </Button>
            </div>
          :null
        }
        <SneakerLoadingSpinner
          isLoading={this.state.loadingHotProducts && this.state.pageHotProducts > 1}
          isHide={!this.state.hasMoreHotProducts}
          wrapperRef={loadingRef => this.loadingRef = loadingRef}
        />
      </div>
    )
  }

  // most popular
  getProductListMostPopular = () => {
    // const { dataCategory } = this.props;
    const { pageMostPopular, searchCategory } = this.state;
    const payload = {
      params: {
        category: searchCategory,
        per_page: 20,
        page: pageMostPopular,
        range_value: 50
      }
    }

    let paramCheck = this.props.location.pathname.includes("most-popular")
    let categoryUrl = this.props.location.pathname.includes("local-brands") ? "madeindonesia" : searchCategory

    this.setState({ loadingMostPopular: true });

    if(paramCheck){
      this.props.sortingSearchResultAPI('', {
        params: {
          category: categoryUrl,
          sort_by: 'most_popular',
          page: pageMostPopular,
          availables: true,
        },
      })
    } else {
      this.props.getTopSellingProduct(payload)
    }
    this.setState({ loadingMostPopular: false, pageMostPopular: pageMostPopular + 1 })
    this.setState({ loadingMostPopular: false })
  }

  _handleNextPageClickMostPopular = async () => {
    if(!this.state.loadingMostPopular && this.state.hasMoreMostPopular){
      this.getProductListMostPopular();
    }
  }

  async handleObserverMostPopular(entities, observer) {
    // const { dataCategory } = this.props;
    const { searchCategory } = this.state;
    const { data, isFetching, pagination } = this.props.dataTopSelling;

    const y = entities[0].boundingClientRect.y;
    if (this.state.hasMoreMostPopular && !isFetching) {
      if (this.state.prevYMostPopular > y) {
        this.getProductListMostPopular();
      }
      this.setState({ prevYMostPopular: y });
    }
  }

  renderProductsMostPopular() {
    // const isUnreleased = this.props.statusPage === 'unreleased' ? false : true;
    const { dataTrendingNow } = this.props
    const { data, isFetching } = this.props.dataTopSelling;
    const paramCheck = this.props.location.pathname.includes("most-popular")
    
    if (isFetching && (data && data.length === 0)) {
      return <CardLoading />
    } else if ((paramCheck && dataTrendingNow.length <= 0) || (!paramCheck && data.length <= 0)) {
      return (
        <Container className="page-container" style={{ minHeight:500,  display:'flex', alignItems:'center', flexDirection:'row' }}>
          <div style={{ flex:1 }}>
              <div style={{ width:200, margin:" 0px auto" }}>
                  <h3 className="text-center">Mohon Maaf!</h3>
                  <h5 className="text-center">Sneaker tidak ditemukan. Hubungi kami di Whatsapp untuk request produk baru.</h5>
              </div>
          </div>
        </Container>
      )
    } else {
      if(paramCheck){
        return dataTrendingNow.map((item, index) => {
          return <Sneaker 
            {...item} 
            hotProducts={this.props.hotProducts} 
            category={this.state.searchCategory} 
            key={index} 
            // outOfStock={isUnreleased} 
            statusPage={this.props.statusPage}
          />
        })
      } else {
        return data.map((item, index) => (
          <Sneaker 
            {...item} 
            hotProducts={this.props.hotProducts} 
            category={this.state.searchCategory} 
            key={index} 
            // outOfStock={isUnreleased} 
            statusPage={this.props.statusPage}
          />
        ))
      }
    }
  }

  renderListMostPopular() {
    return (
      <div className="product-list">
        <div id="product">
          <Row style={{ minHeight:500, display:'flex',alignItems:'flex-start', flexDirection:'row' }}>
            { this.renderProductsMostPopular() }
          </Row>
        </div>
        {
          !this.state.isInfiniteScrolLMostPopular?
            <div className="d-flex justify-content-center">
              <Button
                block
                size={"lg"}
                type="button"
                onClick={this._handleNextPageClick}
                className={classNames('button-load-more browse__all',{'d-none': this.state.loadingMostPopular || !this.state.hasMoreMostPopular})}
              >
                Load More
              </Button>
            </div>
          :null
        }
        <SneakerLoadingSpinner
          isLoading={this.state.loadingMostPopular && this.state.pageMostPopular > 1}
          isHide={!this.state.hasMoreMostPopular}
          wrapperRef={loadingRef => this.loadingRef = loadingRef}
        />
      </div>
    )
  }

  render() {
    const { dataProduct, searchKeyword, dataSection } = this.props;
    const notFound = dataProduct.searchResult.length === 0 || dataProduct.errorMessageSearch === "Sneaker tidak tersedia!" ||
      dataProduct.errorMessageSearch === "Not Found"

    let leftOpen = this.state.leftOpen ? 'open' : 'closed';
    let rightOpen = this.state.rightOpen ? 'open' : 'closed';

    let isFilterOpen = this.props.isFilterOpen ? 'open' : 'closed';

    //filter and sort
    const params = getQueryParamsUrl(this.props.history.location.search);
    const arrayOfObj = Object.keys(params).map((key) => [(key), params[key]]);

    let { brands } = this.props.dataFilter;
    const selectedBrand = brands.find(brand => brand.id === 1);

    //collection page
    const { isCollectionPage, isHotProductsPage, searchCategory } = this.state;
    const filterParams = [
      { key: "color", value: params.colours },
      { key: "sex", value: params.sex },
      // { key: "filterPrice", value: params },
      { key: "startPrice", value: params.startPrice },
      { key: "endPrice", value: params.endPrice },
      { key: "brands", value: params.brands },
      { key: "sneakers_condition", value: params.sneakersCondition },
      { key: "sizeId", value: params.sizeId },
      { key: "sizeTypes", value: params.sizeTypes },
      { key: "sizes", value: params.sizes }
    ]

    const { imageLandscape, imagePortrait } = this.props.dataCollection;

    //hot product
    const landscapeImage = dataSection.data &&  dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "landscape") : null;
    const portraitImage = dataSection.data &&  dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "portrait") : null;
    const mobileBanner = portraitImage ? portraitImage.URL : null;
    const bannerImageURL = searchCategory === "handbags"? `${ASSET_IMAGE}/assets-image/hot-products-luxury-landscape.jpg` : `${ASSET_IMAGE}/assets-image/editors-pick-details.jpg`;

    const { isFetching: isLoading, slug, collectionType, products: { data, isFetching } } = this.props.dataProduct;

    //most popular
    const imageBanner = landscapeImage ? landscapeImage.URL : null;
    const appBanner = portraitImage ? portraitImage.URL : null;

    return (

      <Container fluid id="search__result__container">
        {
          isCollectionPage &&
          <>
            <div className="d-none d-sm-block">
              <Banner
                src={getCloudImageUrl(imageLandscape, 1024)}
                alt={`${RESOURCE_URL}/assets-image/editors-pick-details.jpg`}
              />
            </div>
            <div className="d-block d-sm-none">
              <Banner
                src={getCloudImageUrl(imagePortrait, 1024)}
                alt={`${RESOURCE_URL}/assets-image/editors-pick-details.jpg`}
              />
            </div>
          </>
        }
        {
          isHotProductsPage ?
          <>
            <div className="d-none d-sm-block">
              <Banner
                src={bannerImageURL}
                alt="hot-products"
              />
            </div>
            <div className="d-block d-sm-none">
              <Banner 
                src={getCloudImageUrl(mobileBanner, 1500, "editors-pick")}
                alt={mobileBanner}
              />
            </div>
          </>
          :
          <>
            <div className="d-none d-sm-block">
              <Banner
                src={getCloudImageUrl(imageBanner, 1500, "top-selling")}
                alt={imageBanner}
              />
            </div>
            <div className="d-block d-sm-none">
              <Banner 
                src={getCloudImageUrl(appBanner, 1500, "top-selling")}
                alt={appBanner}
              />
            </div>
          </>
        }
        <Row className="filter__sort__product">
          <Col style={{ padding: 0 }} lg="1" md="2" sm="2" xs="6" className="border__btn__bottom btn__filter">
            {
              this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-left"></i></span>
              </div>
            }
            {
              !this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-right"></i></span>
              </div>
            }
          </Col>

          <Col style={{ padding: 0 }} lg="9" md="7" sm="7" xs="" className={"selected-sort-filter"}>
            <Row className="scroll-wrapper">
              <SelectedFilter
                searchKeyword={this.state.keyword_search}
                removeFilter={this.removeFilter}
                selectedCategory={this.props.match.params.category}
                // data={arrayOfObj}
                data={filterParams}
                // history={this.props.history}
                color={this.props.dataFilter.color}
                sex={this.props.dataFilter.sex}
                startPrice={this.props.dataFilter.startPrice}
                endPrice={this.props.dataFilter.endPrice}
                brands={this.props.dataFilter.brands}
                sneakers_condition={this.props.dataFilter.sneakers_condition}
                brandList={this.props.brandList}
                resetFilter={this.resetFilter}
              // filterCondition={(key, value) => this.filterCondition(key, value)}
              />
            </Row>
          </Col>

          <Col style={{ padding: 0 }} lg="2" md="3" sm="3" xs="6" className={`border__btn__bottom btn__sort`}>
            {
              this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-up"></i>
              </div>
            }
            {
              !this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-down"></i>
              </div>
            }
            {
              this.props.isSortOpen &&
              this.renderSortDropdown()
            }
          </Col>
        </Row>
        <Row className="filter__sort__product">
          <Col style={{ padding: 0 }} lg="9" md="7" sm="7" xs="12" className={"selected-sort-filter-mobile"}>
            <Row className="scroll-wrapper">
              <SelectedFilter
                searchKeyword={this.state.keyword_search}
                removeFilter={this.removeFilter}
                selectedCategory={this.props.match.params.category}
                // data={arrayOfObj}
                data={filterParams}
                // history={this.props.history}
                color={this.props.dataFilter.color}
                sex={this.props.dataFilter.sex}
                startPrice={this.props.dataFilter.startPrice}
                endPrice={this.props.dataFilter.endPrice}
                brands={this.props.dataFilter.brands}
                sizes={this.props.dataFilter.sizes}
                sneakers_condition={this.props.dataFilter.sneakers_condition}
                brandList={this.props.brandList}
              // filterCondition={(key, value) => this.filterCondition(key, value)}
              />
            </Row>
          </Col>
        </Row>

        <div className="product-list search__result">

          <div id='filter' className={isFilterOpen} >
            <div className={`sidebar ${isFilterOpen}`} >

              <div className='content filter'>
                {this.renderFilterDropdown()}
              </div>
            </div>
          </div>

          <div id='product' ref={ref => (this.productContainerRef = ref)}>
            <div className='content'>
              {/* {
                isCollectionPage ?
                  this.renderCollectionPage() :
                  (
                    isHotProductsPage ?
                    this.renderHotProducts() :
                    this.checkingSearchResult()
                  )
              } */}
              {
                isHotProductsPage ?
                  this.renderHotProducts() :
                  this.renderListMostPopular()
              }
              {/* {this._renderSearchBox()} */}
              {/* {
                notFound? null
                :
                <FilterAndSort
                  history={this.props.history}
                  match={this.props.match}
                  typeFilter="SEARCH_PRODUCT"
                  onResetPageNumber={() =>
                    this.setState({ page: 1, isLoading: true })
                  }
                />
              } */}
              {
                !isHotProductsPage &&
                  <>
                    {!isCollectionPage && !this.state.isLoading &&
                      !this.state.hasMore &&
                      this.props.dataProduct.searchResult.length > 0 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center"
                        }}
                      >
                        {/* <p className="text-center">--- You are on bottom list. ---</p> */}
                      </div>
                    ) : null}
                    {!isCollectionPage && !this.state.isInfiniteScrolL ? (
                      <div className="d-flex justify-content-center">
                        <Button
                          block
                          size={"lg"}
                          type="button"
                          onClick={this._handleNextPageClick}
                          className={classNames("button-load-more browse__all", {
                            "d-none": this.state.isLoading || !this.state.hasMore
                          })}
                        >
                          Load More
                        </Button>
                      </div>
                    ) : null}
                    <SneakerLoadingSpinner
                      isLoading={isCollectionPage ? (isFetching && this.state.page > 1 || (isLoading && data.length === 0)) : (this.state.isLoading && this.state.page > 1)}
                      isHide={isCollectionPage ? (!isFetching) : (!this.state.hasMore)}
                      wrapperRef={isCollectionPage ? (loadingRef => this.loadingRef = loadingRef) : (loadingRef => (this.loadingRef = loadingRef))} />
                  </>
              }
            </div>

          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataProduct: state.dataProduct,
  activeId: state.dataProduct.activeId,
  dataPopular: state.dataProduct.productPopulars,
  dataCategory: state.dataCategory,

  //filter and sort
  isSortOpen: state.dataUi.isSortOpen,
  isFilterOpen: state.dataUi.isFilterOpen,
  dataFilter: state.filterReducer,
  brandList: state.filterReducer.brands,

  //collection page
  dataCollection: state.dataProduct.collection,
  searchKeyword: state.dataProduct.searchKeyword,

  //hot products
  dataSection: state.dataProduct.dataSection,

  //most popular
  dataTopSelling: state.dataProduct.topSelling,
  // dataCategory: state.dataCategory.selected,
  dataTrendingNow: state.dataProduct.searchResult
});

const mapDispatchToProps = dispatch => {
  return {
    searchProduct: params => dispatch(searchProduct(params)),
    doBrowseAll: (page, status_action) =>
      dispatch(doBrowseAll(page, status_action)),
    getList: query => dispatch(doFetchProducts(query)),
    doFilteringSearchToApi: (params, page, action) =>
      dispatch(doFilteringSearchToApi(params, page, action)),
    searchToLoadMore: params => dispatch(searchToLoadMore(params)),
    updateActiveId: (id) => dispatch(updateActiveId(id)),
    sortingSearchResultAPI: (paramsRoute, caseSort, status_action) =>
      dispatch(sortingSearchResultAPI(paramsRoute, caseSort, status_action)),
    saveSearchQueries: dataSearch => dispatch(saveSearchQueries(dataSearch)),
    getPopularSearch: params => dispatch(doFetchPopularSearch(params)),
    hideLoading: () => dispatch(hideLoading()),

    //filter and sort
    sortingSearchResultAPI: (paramsRoute, caseSort, status_action) => dispatch(sortingSearchResultAPI(paramsRoute, caseSort, status_action)),
    getAllBrands: (query) => dispatch(getAllBrands(query)),
    getAllSizes: (query) => dispatch(getAllSizes(query)),
    getPopularSearch: (query) => dispatch(doFetchPopularSearch(query)),
    setSortBy: payload => dispatch(doSetSortBySearch(payload)),
    setFilter: payload => dispatch(doSetFilterSearch(payload)),

    //collection page
    getCollectionBySlug: (category, slug) => dispatch(getCollectionBySlug(category, slug)),
    getCollectionProduct: (id, payload) => dispatch(getCollectionProduct(id, payload)),
    searchState: (keyword) => dispatch(searchState(keyword)),
    fetchCollectionProduct: (payload, filterQueries) => dispatch(fetchCollectionProduct(payload, filterQueries)),

    // for refreshing currency rate
    fetchProfile: () => dispatch(doFetchProfile()),
    fetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),

    //hot products
    getAdditionalPage: (type, params) => dispatch(getAdditionalPage(type, params)),
    getDetailSection: (category, type) => dispatch(getDetailSection(category, type)),

    //most popular
    getTopSellingProduct: (params) => dispatch(getTopSellingProduct(params))
  };
};

const connectRedux = connect(mapStateToProps, mapDispatchToProps);

export default connectRedux(withScrollTo(withRouter(PageSearchDetailsTPO)));

// PageSearchDetailsTPO.defaultProps = {
//   scrollStepInPx: 50,
//   delayInMs: 10
// }